<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div
            v-if="loading"
            class="card-body d-flex align-items-center justify-content-center"
            style="height: calc(100vh - 144px)"
          >
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </div>
          <div class="card-body" v-if="!loading">
            <template v-if="!loading">
              <div class="d-flex bd-highlight mb-3">
                <div class="me-auto p-2 bd-highlight">
                  <h4 class="card-title">{{ detail.name.toUpperCase() }}</h4>
                  <!-- Card Title -->
                </div>

                <div class="p-2 bd-highlight">
                  <button
                    type="button"
                    class="btn btn-primary waves-effect waves-light"
                    @click="
                      $router.push(
                        '/mpg/organizations/' + detail.organization_id + '/edit'
                      )
                    "
                  >
                    Edit
                  </button>
                </div>

                <div class="p-2 bd-highlight">
                  <button
                    type="button"
                    class="btn btn-danger waves-effect waves-light"
                    v-b-modal.delete_org_modal
                  >
                    Delete
                  </button>
                </div>
              </div>

              <b-modal
                id="delete_org_modal"
                tabindex="-1"
                aria-labelledby="delete_modal_label"
                aria-hidden="true"
                hide-footer
              >
                <template #modal-header>
                  <h6 class="text-center">DELETE {{ detail.name }}</h6>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    :disabled="loadingAction"
                    @click="$bvModal.hide('delete_org_modal')"
                  ></button>
                </template>

                <div class="modal-body">
                  <h3 class="text-center">Are you sure?</h3>
                  <h6 class="text-center">You won't be able to revert this.</h6>
                  <div class="d-grid gap-2 d-md-block text-center">
                    <form method="POST">
                      <input
                        type="hidden"
                        name="csrfmiddlewaretoken"
                        value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                      />
                      <button
                        class="btn btn-danger waves-effect waves-light"
                        type="submit"
                        name="delete_org"
                        value="11"
                        @click="deleteOrg(detail.organization_id)"
                        :disabled="loadingAction"
                      >
                        Delete
                      </button>
                      <button
                        class="btn btn-light waves-effect waves-light"
                        type="button"
                        :disabled="loadingAction"
                        data-bs-dismiss="modal"
                        @click="$bvModal.hide('delete_org_modal')"
                      >
                        Cancel
                      </button>
                    </form>
                  </div>
                </div>
              </b-modal>

              <div class="row">
                <div class="col-lg-12">
                  <b-tabs
                    v-model="tabIndex"
                    class="nav-tabs-custom nav-justified"
                    active-tab-class="p-3"
                    @activate-tab="onChangeTab"
                  >
                    <b-tab>
                      <template #title> Details </template>
                      <b-card-title></b-card-title>
                      <b-card-text>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="card h-100">
                              <div class="card-body">
                                <h4 class="card-title">General</h4>
                                <p></p>
                                <div class="row">
                                  <div class="col-lg-3">
                                    <img
                                      style="
                                        background: #eee3;
                                        border: 1px solid #dddddd21;
                                        height: 100%;
                                        width: 100%;
                                      "
                                      class="img-fluid"
                                      :src="
                                        detail.logo
                                          ? detail.logo
                                          : '/static/img/blank-img.jpeg'
                                      "
                                      alt=""
                                    />
                                  </div>
                                  <div class="col-lg-9">
                                    <div class="table-responsive">
                                      <table
                                        class="
                                          table
                                          align-middle
                                          table-striped table-nowrap
                                          mb-0
                                        "
                                      >
                                        <tbody>
                                          <tr>
                                            <td>Zoom Info ID</td>
                                            <td>
                                              {{ detail.zoominfo_id }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Tax ID</td>

                                            <td>{{ detail.tax_id }}</td>
                                          </tr>

                                          <tr>
                                            <td>DUNS Number</td>

                                            <td>
                                              {{ detail.duns_number }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Experian ID</td>

                                            <td>{{ detail.bin_number }}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-4">
                          <div class="col-12">
                            <div class="card h-100">
                              <div class="card-body">
                                <h4 class="card-title">Corporate Profile</h4>
                                <p></p>
                                <div class="row">
                                  <div class="col-lg-6 mb-3">
                                    <div class="table-responsive">
                                      <table
                                        class="
                                          table
                                          align-middle
                                          table-striped table-nowrap
                                          mb-0
                                        "
                                      >
                                        <tbody>
                                          <tr>
                                            <td>Legal Entity Name</td>
                                            <td>
                                              {{ detail.name.toUpperCase() }}
                                            </td>
                                          </tr>

                                          <tr>
                                            <td>Address</td>

                                            <td>
                                              {{
                                                detail.addresses[0]
                                                  ? detail.addresses[0]
                                                      .address_street
                                                  : ""
                                              }}
                                            </td>
                                          </tr>

                                          <tr>
                                            <td>City</td>

                                            <td>
                                              {{
                                                detail.addresses[0]
                                                  ? detail.addresses[0].city
                                                  : ""
                                              }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>State</td>

                                            <td>
                                              {{
                                                detail.addresses[0]
                                                  ? detail.addresses[0].state
                                                      .name
                                                  : ""
                                              }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Zip Code</td>

                                            <td>
                                              {{
                                                detail.addresses[0]
                                                  ? detail.addresses[0].zip_code
                                                  : ""
                                              }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Phone</td>

                                            <td>{{ detail.phone }}</td>
                                          </tr>
                                          <tr>
                                            <td>Email</td>

                                            <td>{{ detail.email }}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>

                                  <div class="col-lg-6 mb-3">
                                    <table
                                      class="
                                        table
                                        align-middle
                                        table-striped table-nowrap
                                        mb-0
                                      "
                                    >
                                      <tbody>
                                        <tr>
                                          <td>Last Verification Date</td>
                                          <td>
                                            {{
                                              detail.last_verification_date
                                                ? moment(
                                                    detail.last_verification_date
                                                  ).format("MMM DD, YYYY")
                                                : ""
                                            }}
                                          </td>
                                        </tr>

                                        <tr>
                                          <td>State of Incorporation</td>

                                          <td>
                                            {{ detail.state_of_incorporation }}
                                          </td>
                                        </tr>

                                        <tr>
                                          <td>Founding Year</td>

                                          <td>
                                            {{ detail.founding_year }}
                                          </td>
                                        </tr>

                                        <tr>
                                          <td>Type</td>

                                          <td>
                                            {{ detail.type }}
                                          </td>
                                        </tr>

                                        <tr>
                                          <td>Structure</td>

                                          <td>
                                            {{ detail.structure }}
                                          </td>
                                        </tr>

                                        <tr>
                                          <td>MPG ID</td>
                                          <td>
                                            {{ detail.mpg_internal_id }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Web</td>

                                          <td>{{ detail.web_page }}</td>
                                        </tr>

                                        <!-- <tr>
                                          <td>FEIN</td>

                                          <td>
                                            {{ detail.duns_number }}
                                          </td>
                                        </tr> -->
                                      </tbody>
                                    </table>
                                  </div>

                                  <!-- <div class="col-lg-4 mb-3">
                                    <div class="card h-100">
                                      <div class="card-body">
                                        <h4 class="card-title">Industry</h4>
                                        <p></p>
                                        <div class="table-responsive">
                                          <table
                                            class="
                                              table
                                              align-middle
                                              table-striped table-nowrap
                                              mb-0
                                            "
                                          >
                                            <tbody>
                                              <tr>
                                                <td>Primary Industry</td>
                                                <td>
                                                  {{ detail.primary_industry }}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <p></p>
                                          <p></p>
                                          <h4 class="card-title">NAICS</h4>
                                          <p></p>
                                          <table
                                            class="
                                              table
                                              align-middle
                                              table-striped table-nowrap
                                              mb-0
                                            "
                                          >
                                            <tbody>
                                              <tr
                                                v-for="naic in detail.naics"
                                                :key="naic"
                                              >
                                                <td>
                                                  {{ getNameNaic(naic) }}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div> -->

                                  <!-- <div class="col-lg-4 mb-3">
                                    <div class="card h-100">
                                      <div class="card-body">
                                        <h4 class="card-title">
                                          Operation Metrics
                                        </h4>
                                        <p></p>

                                        <div class="table-responsive">
                                          <table
                                            class="
                                              table
                                              align-middle
                                              table-striped table-nowrap
                                              mb-0
                                            "
                                          >
                                            <tbody>
                                              <tr>
                                                <td>Age</td>

                                                <td>
                                                  {{
                                                    new Date().getFullYear() +
                                                    "-" +
                                                    detail.founding_year
                                                  }}
                                                </td>
                                              </tr>

                                              <tr>
                                                <td>Number of Locations</td>

                                                <td>
                                                  {{
                                                    detail.number_of_locations
                                                  }}
                                                </td>
                                              </tr>

                                              <tr>
                                                <td>Estimated Revenue</td>

                                                <td>
                                                  {{ detail.estimated_revenue }}
                                                </td>
                                              </tr>

                                              <tr>
                                                <td>
                                                  Estimated Employee Count
                                                </td>

                                                <td>
                                                  {{
                                                    detail.estimated_emplpoyee_count
                                                  }}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div> -->
                                  <!-- <div class="col-lg-12 mb-3">
                                    <div class="card h-100">
                                      <div class="card-body">
                                        <h4 class="card-title">Risk Profile</h4>
                                        <p></p>
                                        <div class="row">
                                          <div class="col-12 col-lg-5">
                                            <div class="row">
                                              <div class="col-12 col-lg-6 mb-2">
                                                <a
                                                  href="javascript:;"
                                                  target="_blank"
                                                  class="
                                                    btn btn-dark btn-sm
                                                    w-100
                                                    mb-3
                                                  "
                                                  >IPV2 Score</a
                                                >
                                              </div>
                                              <div class="col-12 col-lg-6 mb-2">
                                                <a
                                                  href="javascript:;"
                                                  target="_blank"
                                                  class="
                                                    btn btn-dark btn-sm
                                                    w-100
                                                    mb-3
                                                  "
                                                  >Paydex Score</a
                                                >
                                              </div>
                                              <div class="col-12 col-lg-6 mb-2">
                                                <a
                                                  href="javascript:;"
                                                  target="_blank"
                                                  class="
                                                    btn btn-dark btn-sm
                                                    w-100
                                                    mb-3
                                                  "
                                                  >Past Bankruptcy Count</a
                                                >
                                              </div>
                                              <div class="col-12 col-lg-6 mb-2">
                                                <a
                                                  href="javascript:;"
                                                  target="_blank"
                                                  class="
                                                    btn btn-dark btn-sm
                                                    w-100
                                                    mb-3
                                                  "
                                                  >Trade Lines Found Count</a
                                                >
                                              </div>
                                              <div class="col-12 col-lg-6 mb-2">
                                                <a
                                                  href="javascript:;"
                                                  target="_blank"
                                                  class="
                                                    btn btn-dark btn-sm
                                                    w-100
                                                    mb-3
                                                  "
                                                  >Current Lien Count</a
                                                >
                                              </div>
                                              <div class="col-12 col-lg-6 mb-2">
                                                <a
                                                  href="javascript:;"
                                                  target="_blank"
                                                  class="
                                                    btn btn-dark btn-sm
                                                    w-100
                                                    mb-3
                                                  "
                                                  >Current Lien Value</a
                                                >
                                              </div>
                                              <div class="col-12 col-lg-6 mb-2">
                                                <a
                                                  href="javascript:;"
                                                  target="_blank"
                                                  class="
                                                    btn btn-dark btn-sm
                                                    w-100
                                                    mb-3
                                                  "
                                                  >Current Judgment Count</a
                                                >
                                              </div>
                                              <div class="col-12 col-lg-6 mb-2">
                                                <a
                                                  href="javascript:;"
                                                  target="_blank"
                                                  class="
                                                    btn btn-dark btn-sm
                                                    w-100
                                                    mb-3
                                                  "
                                                  >Current Judgment Value</a
                                                >
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-12 col-lg-7">
                                            <ul class="list-group">
                                              <li
                                                class="
                                                  list-group-item
                                                  border-0
                                                  d-flex
                                                  justify-content-between
                                                  p-0
                                                  mb-2
                                                  border-radius-lg
                                                "
                                              >
                                                <div
                                                  class="
                                                    w-100
                                                    d-flex
                                                    align-items-center
                                                    text-sm
                                                  "
                                                >
                                                  <div
                                                    class="
                                                      w-100
                                                      d-flex
                                                      align-items-center
                                                      justify-content-center
                                                    "
                                                  >
                                                    <div class="w-100 px-2">
                                                      <span
                                                        class="
                                                          me-2
                                                          text-xs
                                                          font-weight-bold
                                                        "
                                                        >Experian
                                                        Pre-Qualification
                                                        Report</span
                                                      >
                                                      <div class="progress">
                                                        <div
                                                          class="
                                                            progress-bar
                                                            bg-gradient-success
                                                          "
                                                          role="progressbar"
                                                          aria-valuenow="100"
                                                          aria-valuemin="0"
                                                          aria-valuemax="100"
                                                          style="width: 100%"
                                                        ></div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <input
                                                    class="
                                                      form-check-input
                                                      mt-2
                                                    "
                                                    type="checkbox"
                                                    value=""
                                                    id="defaultCheck1"
                                                  />
                                                </div>
                                              </li>
                                              <li
                                                class="
                                                  list-group-item
                                                  border-0
                                                  d-flex
                                                  justify-content-between
                                                  p-0
                                                  mb-2
                                                  border-radius-lg
                                                "
                                              >
                                                <div
                                                  class="
                                                    w-100
                                                    d-flex
                                                    align-items-center
                                                    text-sm
                                                  "
                                                >
                                                  <div
                                                    class="
                                                      w-100
                                                      d-flex
                                                      align-items-center
                                                      justify-content-center
                                                    "
                                                  >
                                                    <div class="w-100 px-2">
                                                      <span
                                                        class="
                                                          me-2
                                                          text-xs
                                                          font-weight-bold
                                                        "
                                                        >Experian Trade Lines
                                                        Report</span
                                                      >
                                                      <div class="progress">
                                                        <div
                                                          class="
                                                            progress-bar
                                                            bg-gradient-success
                                                          "
                                                          role="progressbar"
                                                          aria-valuenow="100"
                                                          aria-valuemin="0"
                                                          aria-valuemax="100"
                                                          style="width: 100%"
                                                        ></div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <input
                                                    class="
                                                      form-check-input
                                                      mt-2
                                                    "
                                                    type="checkbox"
                                                    value=""
                                                    id="defaultCheck1"
                                                  />
                                                </div>
                                              </li>
                                              <li
                                                class="
                                                  list-group-item
                                                  border-0
                                                  d-flex
                                                  justify-content-between
                                                  p-0
                                                  mb-2
                                                  border-radius-lg
                                                "
                                              >
                                                <div
                                                  class="
                                                    w-100
                                                    d-flex
                                                    align-items-center
                                                    text-sm
                                                  "
                                                >
                                                  <div
                                                    class="
                                                      w-100
                                                      d-flex
                                                      align-items-center
                                                      justify-content-center
                                                    "
                                                  >
                                                    <div class="w-100 px-2">
                                                      <span
                                                        class="
                                                          me-2
                                                          text-xs
                                                          font-weight-bold
                                                        "
                                                        >Parentage Report</span
                                                      >
                                                      <div class="progress">
                                                        <div
                                                          class="
                                                            progress-bar
                                                            bg-gradient-warning
                                                          "
                                                          role="progressbar"
                                                          aria-valuenow="60"
                                                          aria-valuemin="0"
                                                          aria-valuemax="100"
                                                          style="width: 60%"
                                                        ></div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <input
                                                    class="
                                                      form-check-input
                                                      mt-2
                                                    "
                                                    type="checkbox"
                                                    value=""
                                                    id="defaultCheck1"
                                                  />
                                                </div>
                                              </li>
                                              <li
                                                class="
                                                  list-group-item
                                                  border-0
                                                  d-flex
                                                  justify-content-between
                                                  p-0
                                                  mb-2
                                                  border-radius-lg
                                                "
                                              >
                                                <div
                                                  class="
                                                    w-100
                                                    d-flex
                                                    align-items-center
                                                    text-sm
                                                  "
                                                >
                                                  <div
                                                    class="
                                                      w-100
                                                      d-flex
                                                      align-items-center
                                                      justify-content-center
                                                    "
                                                  >
                                                    <div class="w-100 px-2">
                                                      <span
                                                        class="
                                                          me-2
                                                          text-xs
                                                          font-weight-bold
                                                        "
                                                        >Liens, Judgements and
                                                        Bankruptcy Report</span
                                                      >
                                                      <div class="progress">
                                                        <div
                                                          class="
                                                            progress-bar
                                                            bg-gradient-success
                                                          "
                                                          role="progressbar"
                                                          aria-valuenow="100"
                                                          aria-valuemin="0"
                                                          aria-valuemax="100"
                                                          style="width: 100%"
                                                        ></div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <input
                                                    class="
                                                      form-check-input
                                                      mt-2
                                                    "
                                                    type="checkbox"
                                                    value=""
                                                    id="defaultCheck1"
                                                  />
                                                </div>
                                              </li>
                                              <li
                                                class="
                                                  list-group-item
                                                  border-0
                                                  d-flex
                                                  justify-content-between
                                                  p-0
                                                  mb-2
                                                  border-radius-lg
                                                "
                                              >
                                                <div
                                                  class="
                                                    w-100
                                                    d-flex
                                                    align-items-center
                                                    text-sm
                                                  "
                                                >
                                                  <div
                                                    class="
                                                      w-100
                                                      d-flex
                                                      align-items-center
                                                      justify-content-center
                                                    "
                                                  >
                                                    <div class="w-100 px-2">
                                                      <span
                                                        class="
                                                          me-2
                                                          text-xs
                                                          font-weight-bold
                                                        "
                                                        >Funding History
                                                        Report</span
                                                      >
                                                      <div class="progress">
                                                        <div
                                                          class="
                                                            progress-bar
                                                            bg-gradient-success
                                                          "
                                                          role="progressbar"
                                                          aria-valuenow="0"
                                                          aria-valuemin="0"
                                                          aria-valuemax="100"
                                                          style="width: 0%"
                                                        ></div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <input
                                                    class="
                                                      form-check-input
                                                      mt-2
                                                    "
                                                    type="checkbox"
                                                    value=""
                                                    id="defaultCheck1"
                                                  />
                                                </div>
                                              </li>
                                            </ul>
                                            <div class="row">
                                              <div class="col-12 text-end">
                                                <button
                                                  type="button"
                                                  class="
                                                    btn btn-light
                                                    waves-effect waves-light
                                                  "
                                                >
                                                  Download
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div> -->

                                  <!-- <div class="col-lg-4 mb-3">
                                    <div class="card h-100">
                                      <div class="card-body">
                                        <h4 class="card-title">Web Presense</h4>
                                        <p></p>
                                        <div class="table-responsive">
                                          <table
                                            class="
                                              table
                                              align-middle
                                              table-striped table-nowrap
                                              mb-0
                                            "
                                          >
                                            <tbody>
                                              <tr>
                                                <td>Glassdoor URL</td>
                                                <td>
                                                  {{ detail.glassdoor }}
                                                </td>
                                              </tr>

                                              <tr>
                                                <td>LinkedIn URL</td>

                                                <td>{{ detail.linkedin }}</td>
                                              </tr>

                                              <tr>
                                                <td>Twitter</td>

                                                <td>
                                                  {{ detail.twitter }}
                                                </td>
                                              </tr>

                                              <tr>
                                                <td>Facebook</td>

                                                <td>{{ detail.facebook }}</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div> -->
                                </div>
                                <p></p>
                                <p></p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mt-4">
                          <div class="col-lg-8">
                            <div class="card">
                              <div class="card-header pb-0 px-3">
                                <h4 class="mb-0 card-title">Notes</h4>
                              </div>
                              <div class="card-body pt-4 p-3">
                                <!-- <div v-if="!listNotes">Getting notes...</div> -->
                                <!-- v-for="(note, i) in listNotes" -->

                                <ul class="list-group">
                                  <li
                                    :key="i"
                                    class="
                                      list-group-item
                                      border-0
                                      d-flex
                                      p-4
                                      mb-2
                                      bg-gray-100
                                      border-radius-lg
                                    "
                                  >
                                    <div class="d-flex flex-column">
                                      <b-modal
                                        :id="'delete_node_modal'"
                                        tabindex="-1"
                                        aria-labelledby="delete_  node_modal"
                                        aria-hidden="true"
                                        hide-footer
                                      >
                                        <template #modal-header>
                                          <h6 class="text-center">
                                            DELETE THIS NOTE
                                          </h6>
                                          <button
                                            type="button"
                                            class="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            :disabled="loadingAction"
                                          ></button>
                                        </template>

                                        <div class="modal-body">
                                          <h3 class="text-center">
                                            Are you sure?
                                          </h3>
                                          <h6 class="text-center">
                                            You won't be able to revert this.
                                          </h6>
                                          <div
                                            class="
                                              d-grid
                                              gap-2
                                              d-md-block
                                              text-center
                                            "
                                          >
                                            <form method="POST">
                                              <input
                                                type="hidden"
                                                name="csrfmiddlewaretoken"
                                                value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                                              />
                                              <button
                                                class="
                                                  btn btn-danger
                                                  waves-effect waves-light
                                                "
                                                type="button"
                                                value="11"
                                                :disabled="loadingAction"
                                              >
                                                Delete
                                              </button>
                                              <button
                                                class="
                                                  btn btn-light
                                                  waves-effect waves-light
                                                "
                                                type="button"
                                                :disabled="loadingAction"
                                                data-bs-dismiss="modal"
                                              >
                                                Cancel
                                              </button>
                                            </form>
                                          </div>
                                        </div>
                                      </b-modal>

                                      <b-modal
                                        :id="'delete_edit_modal'"
                                        tabindex="-1"
                                        aria-labelledby="delete_edit_modal"
                                        aria-hidden="true"
                                        hide-footer
                                      >
                                        <template #modal-header>
                                          <h6 class="text-center">EDIT NOTE</h6>
                                          <button
                                            type="button"
                                            class="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            :disabled="loadingAction"
                                          ></button>
                                        </template>

                                        <div class="modal-body">
                                          <div
                                            class="
                                              d-grid
                                              gap-2
                                              d-md-block
                                              text-center
                                            "
                                          >
                                            <form method="POST">
                                              <input
                                                type="hidden"
                                                name="csrfmiddlewaretoken"
                                                value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                                              />
                                              <!-- <VueEditor
                                                v-model="note.description"
                                              /> -->
                                              <p></p>
                                              <p></p>
                                              <button
                                                class="
                                                  btn btn-danger
                                                  waves-effect waves-light
                                                "
                                                type="button"
                                                value="11"
                                                :disabled="loadingAction"
                                              >
                                                Save
                                              </button>
                                              <button
                                                class="
                                                  btn btn-light
                                                  waves-effect waves-light
                                                "
                                                type="button"
                                                :disabled="loadingAction"
                                                data-bs-dismiss="modal"
                                              >
                                                Cancel
                                              </button>
                                            </form>
                                          </div>
                                        </div>
                                      </b-modal>

                                      <h6 class="mb-3 text-sm">Test User</h6>
                                      <span
                                        class="mb-2 text-xs"
                                        v-html="'Test descriton'"
                                      ></span>
                                    </div>
                                    <div class="ms-auto text-end">
                                      <a
                                        class="
                                          btn btn-link
                                          text-danger text-gradient
                                          px-3
                                          mb-0
                                        "
                                        href="javascript:;"
                                        ><i
                                          class="far fa-trash-alt me-2"
                                          aria-hidden="true"
                                        ></i
                                        >Delete</a
                                      >
                                      <a
                                        class="btn btn-link text-dark px-3 mb-0"
                                        href="javascript:;"
                                        ><i
                                          class="
                                            fas
                                            fa-pencil-alt
                                            text-dark
                                            me-2
                                          "
                                          aria-hidden="true"
                                        ></i
                                        >Edit</a
                                      >
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="card m-b-30">
                                  <div class="card-header">
                                    <div class="row align-items-center">
                                      <div class="col-8">
                                        <h5 class="card-title mb-0">
                                          Files (3)
                                        </h5>
                                      </div>
                                      <div class="col-4">
                                        <ul
                                          class="
                                            list-inline-group
                                            text-right
                                            mb-1
                                            pl-0
                                          "
                                        >
                                          <li
                                            class="
                                              list-inline-item
                                              mr-0
                                              font-12
                                            "
                                          >
                                            <i
                                              class="
                                                feather
                                                icon-more-vertical-
                                                font-20
                                                text-primary
                                              "
                                            ></i>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="card-body pt-0">
                                    <div class="product-file-type">
                                      <ul class="list-unstyled">
                                        <li class="media mb-3">
                                          <span
                                            class="
                                              mr-3
                                              align-self-center
                                              img-icon
                                              primary-rgba
                                              text-primary
                                            "
                                            >.doc</span
                                          >
                                          <div class="media-body">
                                            <h5 class="font-16 mb-1">
                                              Marketing Guidelines<i
                                                class="
                                                  feather
                                                  icon-download-cloud
                                                  float-right
                                                "
                                              ></i>
                                            </h5>
                                            <p>.doc, 5.3 MB</p>
                                          </div>
                                        </li>
                                        <li class="media mb-3">
                                          <span
                                            class="
                                              mr-3
                                              align-self-center
                                              img-icon
                                              success-rgba
                                              text-success
                                            "
                                            >.xls</span
                                          >
                                          <div class="media-body">
                                            <h5 class="font-16 mb-1">
                                              Complete Product Sheet<i
                                                class="
                                                  feather
                                                  icon-download-cloud
                                                  float-right
                                                "
                                              ></i>
                                            </h5>
                                            <p>.xls, 2.5 MB</p>
                                          </div>
                                        </li>
                                        <li class="media mb-3">
                                          <span
                                            class="
                                              mr-3
                                              align-self-center
                                              img-icon
                                              danger-rgba
                                              text-danger
                                            "
                                            >.pdf</span
                                          >
                                          <div class="media-body">
                                            <h5 class="font-16 mb-1">
                                              Annual Sales Report 2018-19<i
                                                class="
                                                  feather
                                                  icon-download-cloud
                                                  float-right
                                                "
                                              ></i>
                                            </h5>
                                            <p>.pdf, 10.5 MB</p>
                                          </div>
                                        </li>
                                        <li class="media">
                                          <span
                                            class="
                                              mr-3
                                              align-self-center
                                              img-icon
                                              info-rgba
                                              text-info
                                            "
                                            >.zip</span
                                          >
                                          <div class="media-body">
                                            <h5 class="font-16 mb-1">
                                              Brand Photography<i
                                                class="
                                                  feather
                                                  icon-download-cloud
                                                  float-right
                                                "
                                              ></i>
                                            </h5>
                                            <p>.zip, 53.2 MB</p>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <p></p>
                      </b-card-text>
                    </b-tab>
                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="far fa-contacts"></i
                        ></span>

                        <span class="badge rounded-pill bg-danger float-end">{{
                          detail.contacts.filter(
                            (e) =>
                              e.organizations_contacts.find(
                                (e) =>
                                  e.organization.toString() === $route.params.id
                              ).employment_status !== "active"
                          ).length
                        }}</span>
                        <span
                          class="badge rounded-pill bg-success float-end me-2"
                          >{{
                            detail.contacts.filter(
                              (e) =>
                                e.organizations_contacts.find(
                                  (e) =>
                                    e.organization.toString() ===
                                    $route.params.id
                                ).employment_status === "active"
                            ).length
                          }}</span
                        >

                        <span class="d-none d-sm-block">Contacts</span>
                      </template>
                      <b-card-text>
                        <!-- Start Buttons -->
                        <div class="d-flex flex-wrap gap-2 justify-content-end">
                          <router-link
                            :to="
                              '/mpg/organizations/' +
                              $route.params.id +
                              '/contact/create'
                            "
                            class="btn btn-success waves-effect waves-light"
                          >
                            Create Contact
                          </router-link>

                          <router-link
                            :to="
                              '/mpg/organizations/' +
                              $route.params.id +
                              '/contact/add'
                            "
                            class="btn btn-primary waves-effect waves-light"
                          >
                            Add Contact
                          </router-link>
                        </div>
                        <!-- End Buttons -->

                        <p></p>

                        <div class="card">
                          <div class="card-body">
                            <!-- Start Filter -->
                            <div class="row">
                              <div
                                class="
                                  d-flex
                                  flex-row-reverse
                                  justify-content-between
                                "
                              >
                                <div>
                                  <b-dropdown
                                    id="dropdown-1"
                                    variant="link"
                                    toggle-class="text-reset pt-0"
                                  >
                                    <template #button-content>
                                      <span class="text-muted"
                                        >Property Status:</span
                                      >
                                      <span class="fw-semibold text-capitalize"
                                        >{{ filterStatusContact
                                        }}<i
                                          class="mdi mdi-chevron-down ms-1"
                                        ></i
                                      ></span>
                                    </template>
                                    <b-dropdown-item
                                      @click="filterStatusContact = 'active'"
                                      >Active</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                      @click="filterStatusContact = 'expired'"
                                      >Expired</b-dropdown-item
                                    >
                                  </b-dropdown>
                                </div>
                                <!-- End Filter -->

                                <h4 class="card-title mb-4">Contacts List</h4>
                              </div>
                            </div>
                            <!-- Card Title -->
                            <!-- A partir de aqui -->
                            <div class="row g-1">
                              <div class="table-responsive mb-0">
                                <table
                                  style="overflow: visible"
                                  class="
                                    table table-hover table-borderless
                                    align-middle
                                    table-centered table-nowrap
                                    mt-1
                                    mb-0
                                    ctrl-h
                                  "
                                >
                                  <thead class="table-light">
                                    <tr>
                                      <th></th>
                                      <th>Name</th>
                                      <th>Department</th>
                                      <th>Job Title</th>
                                      <th>Work Email</th>
                                      <th>Work Mobile Phone</th>
                                      <th>Work Office Phone</th>
                                      <th>ICE Handle</th>
                                      <th>Teams Handle</th>
                                      <th>Salutation</th>
                                      <th>Preferred Time of Day for Calls</th>
                                      <th>Preferred Time of Day for Emails</th>
                                      <th>Preferred Day of Week for Calls</th>
                                      <th>Preferred Day of Week for Emails</th>
                                      <th>Preferred Check-in Frequency</th>

                                      <th>Status</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr
                                      v-for="(
                                        contact, index
                                      ) in filteredContact"
                                      :key="index"
                                    >
                                      <td class="text-center">
                                        <router-link
                                          :to="
                                            '/mpg/contacts/' +
                                            contact.contact_id +
                                            '/organization/' +
                                            $route.params.id +
                                            '/edit'
                                          "
                                          class="
                                            btn btn-link
                                            text-primary
                                            mb-0
                                            p-0
                                          "
                                        >
                                          <i class="fas fa-edit text-xs"></i>
                                        </router-link>
                                      </td>
                                      <td>
                                        <router-link
                                          :to="
                                            '/mpg/contacts/' +
                                            contact.contact_id +
                                            '/details'
                                          "
                                        >
                                          {{ contact.title }},
                                          {{ contact.first_name }}
                                          {{ contact.middle_name }}
                                          {{ contact.last_name }}</router-link
                                        >
                                      </td>
                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).department
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).job_title
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).work_email
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).work_mobile
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).work_office_phone
                                        }}
                                      </td>

                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).ice_handle
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).teams_handle
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).salutation
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).prefered_time_day_calls
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).prefered_time_day_emails
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).prefered_time_week_day_calls
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).prefered_time_week_day_emails
                                        }}
                                      </td>
                                      <td>
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).prefered_checkin_frequency
                                        }}
                                      </td>
                                      <td>
                                        <span
                                          :class="
                                            'badge bg-soft text-capitalize ' +
                                            (contact.organizations_contacts.find(
                                              (e) =>
                                                e.organization.toString() ===
                                                $route.params.id
                                            ).employment_status === 'active'
                                              ? 'bg-success  text-white'
                                              : 'bg-danger text-white')
                                          "
                                          >{{
                                            contact.organizations_contacts.find(
                                              (e) =>
                                                e.organization.toString() ===
                                                $route.params.id
                                            ).employment_status
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <!--<div class="row">
                              <div
                                class="col-sm-7 mb-3"
                                v-for="(contact, index) in filteredContact"
                                :key="index"
                              >

                                <div class="card mb-lg-0 h-100">
                                  <div class="card-body">

                                    <div class="float-end">
                                      <router-link
                                        :to="
                                          '/mpg/contacts/' +
                                          contact.contact_id +
                                          '/edit?org_id=' +
                                          $route.params.id
                                        "
                                        class="
                                          btn btn-light
                                          waves-effect
                                          btn-sm
                                        "
                                      >
                                        <i
                                          class="
                                            mdi mdi-square-edit-outline
                                            me-1
                                          "
                                        ></i
                                        >Edit
                                      </router-link>
                                    </div>
                                    <h5 class="my-0 text-primary text-truncate">
                                      <router-link
                                        :to="
                                          '/mpg/contacts/' +
                                          contact.contact_id +
                                          '/details'
                                        "
                                        >{{ contact.first_name }},
                                        {{ contact.last_name }}</router-link
                                      >
                                    </h5>
                                    <p class="card-text">
                                      <br />
                                    </p>
                                    <div class="row">
                                      <div class="col">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
                                          class="text-muted"
                                          >Job Title</a
                                        >
                                        <br />

                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).job_title
                                        }}
                                      </div>

                                      <div class="col">
                                        <a class="text-muted">Email</a>
                                        <br />
                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).email
                                        }}
                                      </div>
                                    </div>
                                    <p></p>

                                    <div class="row">
                                      <div class="col">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
                                          class="text-muted"
                                          >Mobile Phone</a
                                        >
                                        <br />

                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).mobile_phone
                                        }}
                                      </div>
                                      <div class="col">
                                        <a class="text-muted">Office Phone</a>
                                        <br />

                                        {{
                                          contact.organizations_contacts.find(
                                            (e) =>
                                              e.organization.toString() ===
                                              $route.params.id
                                          ).office_phone
                                        }}
                                      </div>
                                    </div>
                                    <div class="float-end">
                                      <h5>
                                        <span
                                          :class="
                                            'badge bg-soft text-capitalize ' +
                                            (contact.organizations_contacts.find(
                                              (e) =>
                                                e.organization.toString() ===
                                                $route.params.id
                                            ).employment_status === 'active'
                                              ? 'bg-success  text-white'
                                              : 'bg-danger text-white')
                                          "
                                          >{{
                                            contact.organizations_contacts.find(
                                              (e) =>
                                                e.organization.toString() ===
                                                $route.params.id
                                            ).employment_status
                                          }}</span
                                        >
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> -->
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>

                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="far fa-addresses"></i
                        ></span>

                        <span class="badge rounded-pill bg-danger float-end">{{
                          detail.addresses.filter(
                            (e) =>
                              e.organizations_addresses[0].property_status !==
                              "active"
                          ).length
                        }}</span>
                        <span
                          class="badge rounded-pill bg-success float-end me-2"
                          >{{
                            detail.addresses.filter(
                              (e) =>
                                e.organizations_addresses[0].property_status ===
                                "active"
                            ).length
                          }}</span
                        >
                        <span class="d-none d-sm-block">Addresses</span>
                      </template>
                      <b-card-text>
                        <!-- Start Buttons -->
                        <div class="d-flex flex-wrap gap-2 justify-content-end">
                          <router-link
                            class="btn btn-success waves-effect waves-light"
                            :to="
                              '/mpg/addresses/create?org_id=' + $route.params.id
                            "
                            >Create Address</router-link
                          >

                          <router-link
                            class="btn btn-primary waves-effect waves-light"
                            :to="
                              '/mpg/organizations/' +
                              $route.params.id +
                              '/address/add'
                            "
                            >Add Address</router-link
                          >
                        </div>
                        <!-- End Buttons -->

                        <p></p>

                        <div class="card">
                          <div class="card-body">
                            <!-- Start Filter -->
                            <div class="row">
                              <div
                                class="
                                  d-flex
                                  flex-row-reverse
                                  justify-content-between
                                "
                              >
                                <div>
                                  <b-dropdown
                                    id="dropdown-1"
                                    variant="link"
                                    toggle-class="text-reset pt-0"
                                  >
                                    <template #button-content>
                                      <span class="text-muted"
                                        >Property Status:</span
                                      >
                                      <span class="fw-semibold text-capitalize"
                                        >{{ filterStatus
                                        }}<i
                                          class="mdi mdi-chevron-down ms-1"
                                        ></i
                                      ></span>
                                    </template>
                                    <b-dropdown-item
                                      @click="filterStatus = 'active'"
                                      >Active</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                      @click="filterStatus = 'expired'"
                                      >Expired</b-dropdown-item
                                    >
                                  </b-dropdown>
                                </div>
                                <!-- End Filter -->

                                <h4 class="card-title mb-4">Addresses List</h4>
                              </div>
                            </div>
                            <!-- Card Title -->
                            <div class="row g-1">
                              <div class="table-responsive mb-0">
                                <table
                                  class="
                                    table table-hover table-borderless
                                    align-middle
                                    table-centered table-nowrap
                                    mt-1
                                    mb-0
                                    ctrl-h
                                  "
                                  style="overflow: visible"
                                >
                                  <thead class="table-light">
                                    <tr>
                                      <th></th>
                                      <th>Full address</th>
                                      <th>City</th>
                                      <th>State</th>
                                      <th>Zip Code</th>
                                      <th>Address Type</th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr
                                      v-for="(
                                        address, index
                                      ) in filteredAddresses"
                                      :key="index"
                                    >
                                      <td class="text-center">
                                        <router-link
                                          :to="
                                            '/mpg/addresses/' +
                                            address.address_id +
                                            '/organization/' +
                                            detail.organization_id +
                                            '/edit'
                                          "
                                          class="
                                            btn btn-link
                                            text-primary
                                            mb-0
                                            p-0
                                          "
                                        >
                                          <i class="fas fa-edit text-xs"></i>
                                        </router-link>
                                      </td>
                                      <td>
                                        <router-link
                                          :to="
                                            '/mpg/addresses/' +
                                            address.address_id +
                                            '/details'
                                          "
                                          >{{
                                            address.address_street +
                                            ", " +
                                            address.state.name +
                                            ", " +
                                            address.city +
                                            ", " +
                                            address.zip_code
                                          }}</router-link
                                        >
                                      </td>
                                      <td>
                                        {{ address.city }}
                                      </td>
                                      <td>
                                        {{ address.state.name }}
                                      </td>
                                      <td>
                                        {{ address.zip_code }}
                                      </td>
                                      <td class="d-flex flex-row gap-2">
                                        <template
                                          v-for="(type, ix) in address
                                            .organizations_addresses[0]
                                            .address_type"
                                        >
                                          <span
                                            :class="
                                              'text-capitalize badge ' +
                                              (type === 'headquarters'
                                                ? 'bg-headq'
                                                : type === 'service_location'
                                                ? 'bg-serv-loc'
                                                : 'bg-bil-addr')
                                            "
                                            :key="ix"
                                            >{{
                                              type === "headquarters"
                                                ? "Headquarters"
                                                : type === "service_location"
                                                ? "Service Location"
                                                : type === "billing_address"
                                                ? "Billing Address"
                                                : type
                                            }}</span
                                          >
                                        </template>
                                      </td>
                                      <td>
                                        <span
                                          :class="
                                            'badge bg-soft text-capitalize ' +
                                            (address.organizations_addresses.find(
                                              (e) =>
                                                e.organization.toString() ===
                                                $route.params.id
                                            ).property_status === 'active'
                                              ? 'bg-success  text-white'
                                              : 'bg-danger text-white')
                                          "
                                          >{{
                                            address.organizations_addresses.find(
                                              (e) =>
                                                e.organization.toString() ===
                                                $route.params.id
                                            ).property_status
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            <!-- <div class="row">
                              <div
                                class="col-sm-7 mb-3"
                                v-for="(address, index) in filteredAddresses"
                                :key="index"
                              >
                                <div class="card mb-lg-0 h-100">
                                  <div class="card-body">
                                    <div class="float-end">
                                      <router-link
                                        :to="
                                          '/mpg/addresses/' +
                                          address.address_id +
                                          '/organization/' +
                                          detail.organization_id +
                                          '/edit'
                                        "
                                        class="
                                          btn btn-light
                                          waves-effect
                                          btn-sm
                                        "
                                      >
                                        <i
                                          class="
                                            mdi mdi-square-edit-outline
                                            me-1
                                          "
                                        ></i
                                        >Edit
                                      </router-link>
                                    </div>
                                    <h5 class="my-0 text-primary text-truncate">
                                      <router-link
                                        :to="
                                          '/mpg/addresses/' +
                                          address.address_id +
                                          '/details'
                                        "
                                        >{{
                                          address.address_street +
                                          ", " +
                                          address.state.name +
                                          ", " +
                                          address.city +
                                          ", " +
                                          address.zip_code
                                        }}</router-link
                                      >
                                    </h5>
                                    <p class="card-text">
                                      <br />

                                      <template
                                        v-for="(
                                          type, ix
                                        ) in address.organizations_addresses.find(
                                          (e) =>
                                            e.organization.toString() ===
                                            $route.params.id
                                        ).address_type"
                                      >
                                        <span
                                          :class="
                                            'badge ' +
                                            (type === 'headquarters'
                                              ? 'bg-primary'
                                              : type === 'service_location'
                                              ? 'bg-warning'
                                              : 'bg-danger')
                                          "
                                          :key="ix"
                                          >{{
                                            type === "headquarters"
                                              ? "Headquarters"
                                              : type === "service_location"
                                              ? "Service Location"
                                              : type === "billing_address"
                                              ? "Billing Address"
                                              : type
                                          }}</span
                                        >
                                        &nbsp;&nbsp;
                                      </template>

                                    </p>
                                    <div class="float-end">
                                      <h5>
                                        <span
                                          :class="
                                            'badge bg-soft text-capitalize ' +
                                            (address.organizations_addresses.find(
                                              (e) =>
                                                e.organization.toString() ===
                                                $route.params.id
                                            ).property_status === 'active'
                                              ? 'bg-success  text-white'
                                              : 'bg-danger text-white')
                                          "
                                          >{{
                                            address.organizations_addresses.find(
                                              (e) =>
                                                e.organization.toString() ===
                                                $route.params.id
                                            ).property_status
                                          }}</span
                                        >
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> -->
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>

                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="far fa-service_opportunities"></i
                        ></span>
                        <span class="badge rounded-pill bg-success float-end">{{
                          detail.bids.length
                        }}</span>
                        <span class="d-none d-sm-block">Bids</span>
                      </template>
                      <b-card-text>
                        <div class="card">
                          <div class="card-body">
                            <h4 class="card-title mb-4">Bids List</h4>
                            <div class="table-responsive">
                              <table
                                class="
                                  table table-hover table-borderless
                                  align-middle
                                  table-centered table-nowrap
                                  mb-0
                                "
                                style="overflow: visible"
                              >
                                <thead class="table-light">
                                  <tr>
                                    <th></th>
                                    <th>Name</th>
                                    <th>Legal Entity</th>
                                    <th>Supplier</th>
                                    <th>Utility State</th>
                                    <th>Annual Volume</th>
                                    <th>Pricing Type</th>
                                    <th>Terms</th>
                                    <th>Start Date</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  <tr
                                    v-for="(bid, index) in detail.bids"
                                    :key="index"
                                  >
                                    <td class="text-center">
                                      <router-link
                                        :to="
                                          '/mpg/opportunities/' +
                                          bid.opportunity +
                                          '/bid/' +
                                          bid.bid_id +
                                          '/edit-from-bid'
                                        "
                                        class="
                                          btn btn-link
                                          text-primary
                                          mb-0
                                          p-0
                                        "
                                      >
                                        <i class="fas fa-edit text-xs"></i>
                                      </router-link>
                                    </td>
                                    <td>
                                      <router-link
                                        :to="
                                          '/mpg/opportunities/' +
                                          bid.opportunity +
                                          '/bid/' +
                                          bid.bid_id
                                        "
                                        >{{ bid.name }}</router-link
                                      >
                                    </td>
                                    <td>{{ detail ? detail.name : "" }}</td>
                                    <td class="text-capitalize">
                                      {{ bid.supplier }}
                                    </td>

                                    <td>
                                      {{
                                        detail.addresses[0]
                                          ? detail.addresses[0].state.name
                                          : ""
                                      }}
                                    </td>

                                    <td>{{ bid.annual_volume }}</td>

                                    <td>
                                      <span
                                        v-for="(
                                          pricing, prixingIndex
                                        ) in bid.pricing_type"
                                        :key="prixingIndex"
                                        class="badge bg-success me-2"
                                        >{{ pricing }}</span
                                      >
                                    </td>
                                    <td>
                                      <span
                                        v-for="(term, termIndex) in bid.terms"
                                        :key="termIndex"
                                        class="badge text-dark bg-warning me-2"
                                        >{{ term }}</span
                                      >
                                    </td>

                                    <td>
                                      {{
                                        bid.start_date
                                          ? moment(bid.start_date).format(
                                              "MM/DD/YYYY"
                                            )
                                          : ""
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>

                    <!-- <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="far fa-addresses"></i
                        ></span>
                        <span class="badge rounded-pill bg-success float-end"
                          >1</span
                        >
                        <span class="d-none d-sm-block">Locations</span>
                      </template>
                      <b-card>
                        <div class="wrap-map" v-if="tabIndex === 2">
                          <MglMap
                            :accessToken="accessToken"
                            :mapStyle="mapStyle"
                            @load="loaded"
                          />
                        </div>
                      </b-card>
                    </b-tab>
                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="far fa-service_opportunities"></i
                        ></span>
                        <span class="badge rounded-pill bg-success float-end"
                          >1</span
                        >
                        <span class="d-none d-sm-block">Contracts</span>
                      </template>
                      <b-card-text>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="card" style="overflow: auto">
                              <div class="card-body" style="overflow: auto">

                                <div class="d-flex justify-content-between">
                                  <h4 class="card-title">Bids</h4>
                                </div>
                                <p></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="far fa-service_opportunities"></i
                        ></span>
                        <span class="badge rounded-pill bg-success float-end"
                          >1</span
                        >
                        <span class="d-none d-sm-block">Opportunities</span>
                      </template>
                      <b-card-text> Empty </b-card-text>
                    </b-tab>
                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="far fa-service_opportunities"></i
                        ></span>
                        <span class="badge rounded-pill bg-success float-end"
                          >1</span
                        >
                        <span class="d-none d-sm-block">Corporate Family</span>
                      </template>
                      <b-card>
                        <h4>Family tree view</h4>
                        <p></p>
                        <vue2-org-tree
                          :data="tree"
                          :label-width="100"
                          :label-class-name="labelClass"
                          :render-content="renderContent"
                          @on-expand="onExpand"
                          @on-node-click="onNodeClick"
                          @on-node-mouseover="onNodeMouseOver"
                          @on-node-mouseout="onNodeMouseOut"
                          @on-node-drop="onNodeDrop"
                          selected-class-name="selected-node"
                          selected-key="selectedKey"
                        />
                        <p></p>
                      </b-card>
                    </b-tab>
                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="far fa-service_opportunities"></i
                        ></span>
                        <span class="badge rounded-pill bg-success float-end"
                          >1</span
                        >
                        <span class="d-none d-sm-block">Inbox</span>
                      </template>
                      <b-card-text> Empty </b-card-text>
                    </b-tab> -->
                  </b-tabs>
                  <!-- End Card -->
                </div>
                <!-- End Col -->
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { organizationsService } from '../services/organizations.service'
import { bidsService } from '../services/bids.service'
import moment from 'moment'
import { MglMap } from 'vue-mapbox'
import 'mapbox-gl/dist/mapbox-gl.css'
import * as mapboxgl from 'mapbox-gl'

export default {
  name: 'OrganizationsDetail',
  components: { MglMap },
  data () {
    return {
      tabIndex: 0,
      detail: null,
      loading: true,
      loadingAction: false,
      map: null,
      filterStatus: 'active',
      filterStatusContact: 'active',
      accessToken: process.env.VUE_APP_MAPBOX_API_KEY,
      mapStyle: 'mapbox://styles/mapbox/dark-v10',
      tree: {
        label: 'Owner',
        children: [
          {
            label: 'Label 1'
          },
          {
            label: 'Label 2'
          },
          {
            label: 'Label 3'
          }
        ]
      }
    }
  },
  computed: {
    filteredContact () {
      return this.detail.contacts.filter((x) => {
        return (
          x.organizations_contacts.find((e) => {
            return e.organization.toString() === this.$route.params.id
          }).employment_status === this.filterStatusContact
        )
      })
    },
    filteredAddresses () {
      return this.detail.addresses.filter((x) => {
        return (
          x.organizations_addresses.find((e) => {
            return e.organization.toString() === this.$route.params.id
          }).property_status === this.filterStatus
        )
      })
    }
  },
  watch: {
    filterStatusContact () {
      // this.detail.contacts.sort((x, y) => {
      //   return x.organizations_contacts.find((e) => {
      //     return e.organization.toString() === this.$route.params.id
      //   }).employment_status === this.filterStatusContact
      //     ? -1
      //     : y.organizations_contacts.find((e) => {
      //       return e.organization.toString() === this.$route.params.id
      //     }).employment_status === this.filterStatusContact
      //       ? 1
      //       : 0
      // })
    },
    filterStatus () {
      // this.detail.addresses.sort((x, y) => {
      //   return x.organizations_addresses.find((e) => {
      //     return e.organization.toString() === this.$route.params.id
      //   }).property_status === this.filterStatus
      //     ? -1
      //     : y.organizations_addresses.find((e) => {
      //       return e.organization.toString() === this.$route.params.id
      //     }).property_status === this.filterStatus
      //       ? 1
      //       : 0
      // })
    }
  },
  created () {
    if (!this.$route.params.id || this.$route.params.id === '') {
      this.$router.push('/mpg/organizations')
    }

    switch (this.$route.params.type) {
      case 'addresses':
        this.tabIndex = 2
        break
      case 'contacts':
        this.tabIndex = 1
        break
      case 'bids':
        this.tabIndex = 3
        break
      default:
        this.tabIndex = 0
        break
    }

    organizationsService.getDataById(this.$route.params.id).then((rs) => {
      this.detail = rs
      this.detail.contacts.sort((x, y) => {
        return x.organizations_contacts.find((e) => {
          return e.organization.toString() === this.$route.params.id
        }).employment_status === this.filterStatusContact
          ? -1
          : y.organizations_contacts.find((e) => {
            return e.organization.toString() === this.$route.params.id
          }).employment_status === this.filterStatusContact
            ? 1
            : 0
      })

      this.detail.addresses.sort((x, y) => {
        return x.organizations_addresses.find((e) => {
          return e.organization.toString() === this.$route.params.id
        }).property_status === this.filterStatus
          ? -1
          : y.organizations_addresses.find((e) => {
            return e.organization.toString() === this.$route.params.id
          }).property_status === this.filterStatus
            ? 1
            : 0
      })
      this.loading = false
    })
  },
  methods: {
    moment,
    deleteOrg (id) {
      this.loadingAction = true
      organizationsService.deleteDataById(id).then((rs) => {
        this.loadingAction = false
        this.$router.push('/mpg/organizations')
      })
    },
    onSubmit () {},
    loaded (event) {
      this.map = event.map
      this.map.addSource('earthquakes', {
        type: 'geojson',
        data: 'https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson',
        cluster: true,
        clusterMaxZoom: 14,
        clusterRadius: 50
      })

      this.map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'earthquakes',
        filter: ['has', 'point_count'],
        paint: {
          'circle-color': [
            'step',
            ['get', 'point_count'],
            '#51bbd6',
            100,
            '#f1f075',
            750,
            '#f28cb1'
          ],
          'circle-radius': [
            'step',
            ['get', 'point_count'],
            20,
            100,
            30,
            750,
            40
          ]
        }
      })

      this.map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'earthquakes',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12
        }
      })

      this.map.addLayer({
        id: 'unclustered-point',
        type: 'circle',
        source: 'earthquakes',
        filter: ['!', ['has', 'point_count']],
        paint: {
          'circle-color': '#11b4da',
          'circle-radius': 4,
          'circle-stroke-width': 1,
          'circle-stroke-color': '#fff'
        }
      })

      // inspect a cluster on click
      this.map.on('click', 'clusters', (e) => {
        const features = this.map.queryRenderedFeatures(e.point, {
          layers: ['clusters']
        })
        const clusterId = features[0].properties.cluster_id
        this.map
          .getSource('earthquakes')
          .getClusterExpansionZoom(clusterId, (err, zoom) => {
            if (err) return

            this.map.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
            })
          })
      })

      // When a click event occurs on a feature in
      // the unclustered-point layer, open a popup at
      // the location of the feature, with
      // description HTML from its properties.
      this.map.on('click', 'unclustered-point', (e) => {
        const coordinates = e.features[0].geometry.coordinates.slice()
        const mag = e.features[0].properties.mag
        const tsunami = e.features[0].properties.tsunami === 1 ? 'yes' : 'no'

        // Ensure that if the map is zoomed out such that
        // multiple copies of the feature are visible, the
        // popup appears over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
        }

        new mapboxgl.Popup()
          .setLngLat(coordinates)
          .setHTML(`magnitude: ${mag}<br>Was there a tsunami?: ${tsunami}`)
          .addTo(this.map)
      })

      this.map.on('mouseenter', 'clusters', () => {
        this.map.getCanvas().style.cursor = 'pointer'
      })
      this.map.on('mouseleave', 'clusters', () => {
        this.map.getCanvas().style.cursor = ''
      })
    },
    labelClass (data) {
      return 'bg_node'
    },
    renderContent (h, data) {
      return h('div', {}, [
        h(
          'img',
          {
            class: 'w-100',
            attrs: {
              src: require('@/assets/img/blank-img.jpeg')
            }
          },
          ''
        ),
        h('p', {}, ''),
        h('p', {}, data.label)
      ])
    },
    onExpand (e, data) {
      if ('expand' in data) {
        data.expand = !data.expand
        if (!data.expand && data.children) {
          this.collapse(data.children)
        }
      } else {
        this.$set(data, 'expand', true)
      }
    },
    collapse (nodes) {
      nodes.forEach((node) => {
        if (node.expand) {
          node.expand = false
        }

        node.children && this.collapse(node.children)
      })
    },
    onNodeClick (e, data) {
      console.log('CLICK', e)
      this.$set(data, 'selectedKey', !data['selectedKey'])
    },
    onNodeMouseOver (e, data) {
      console.log('MOUSE OVER', e, data)
    },
    onNodeMouseOut (e, data) {
      console.log('MOUSE OUT', e)
    },
    onNodeDrop (e, drag, drop) {
      console.log('DROP', e)
      console.log('drag:', drag)
      console.log('drop:', drop)
    },
    getNameNaic (naic) {
      try {
        return naic
      } catch (error) {
        return ''
      }
    },
    onChangeTab (tab) {
      switch (tab) {
        case 0:
          this.$router.push(
            `/mpg/organizations/${this.$route.params.id}/details`
          )
          break
        case 1:
          this.$router.push(
            `/mpg/organizations/${this.$route.params.id}/contacts`
          )
          break
        case 2:
          this.$router.push(
            `/mpg/organizations/${this.$route.params.id}/addresses`
          )
          break
        case 3:
          this.$router.push(`/mpg/organizations/${this.$route.params.id}/bids`)
          break

        default:
          break
      }
    },
    deleteBid (id) {
      bidsService.deleteDataById(id).then((rs) => {
        this.detail.bids = this.detail.bids.filter((e) => e.bid_id !== id)
        this.$bvModal.hide('delete_bid_modal' + id)
      })
    }
  }
}
</script>

<style scoped>
.wrap-map {
  width: 100%;
  height: 600px;
  min-height: 600px;
}
.table.ctrl-h > :not(caption) > * > * {
  padding: 1.067rem 1rem;
}
.badge.bg-serv-loc {
  background: #ecbf69;
}

.badge.bg-bil-addr {
  background: #69bae4;
}

.badge.bg-headq {
  background: #3374b4;
}

.product-file-type .img-icon {
  width: 46px;
  height: 46px;
  line-height: 46px;
  font-weight: 600;
  border-radius: 50%;
  font-size: 18px;
  text-align: center;
  display: block;
}
/* -- Text Color -- */
.text-white {
  color: #ffffff !important;
}

.text-black {
  color: #282828 !important;
}

.text-muted {
  color: #8a98ac !important;
}

.text-primary {
  color: #6e81dc !important;
}

.text-secondary {
  color: #718093 !important;
}

.text-success {
  color: #5fc27e !important;
}

.text-danger {
  color: #f44455 !important;
}

.text-warning {
  color: #fcc100 !important;
}

.text-info {
  color: #72d0fb !important;
}

.text-light {
  color: #dcdde1 !important;
}

.text-dark {
  color: #2d3646 !important;
}

.primary-rgba {
  background-color: rgba(110, 129, 220, 0.1);
}

.secondary-rgba {
  background-color: rgba(113, 128, 147, 0.1);
}

.success-rgba {
  background-color: rgba(95, 194, 126, 0.1);
}

.danger-rgba {
  background-color: rgba(244, 68, 85, 0.1);
}

.warning-rgba {
  background-color: rgba(252, 193, 0, 0.1);
}

.info-rgba {
  background-color: rgba(114, 208, 251, 0.1);
}

.light-rgba {
  background-color: rgba(220, 221, 225, 0.1);
}

.dark-rgba {
  background-color: rgba(45, 54, 70, 0.1);
}

.list-unstyled .media {
  display: flex;
}

.list-unstyled .media-body {
  padding: 0 1rem;
}

.list-unstyled .media-body h5 {
      font-size: 1rem;
}

.list-unstyled .media-body p {
      font-size: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/OrganizationsDetail.vue